import { createAppSlice } from 'app/createAppSlice'

const initialState = {
  tag: {
    size: 10,
    page: 0,
    sortby: undefined,
    sortdir: undefined,
    s: undefined,
    userId: undefined,
  },
  isOpenModal: false,
  loading: false,
}

export const productionUnitSlice = createAppSlice({
  name: 'productionUnit',
  initialState,
  reducers: (create) => ({
    setFetchOption: create.reducer((state, { payload }) => {
      state.tag = { ...state.tag, ...payload }
    }),
    toggleModal: create.reducer((state) => {
      state.isOpenModal = !state.isOpenModal
    }),
  }),
})

export const { setFetchOption, toggleModal } = productionUnitSlice.actions

export default productionUnitSlice.reducer
